module.exports = __webpack_public_path__ + "img/Y2K-kv1.cf7831fd.jpg";